import React, { PropTypes } from 'react'

export default function Media(props) {
	return <a className='article-tease article-tease--tall article-tease--om' href={ props.permalink }>
		<div className='article-tease__title'>{ props.post_title }</div>
		<div className='article-tease__sub-title' dangerouslySetInnerHTML={{ __html: props.chapo }} />
	</a>
}


Media.propTypes = {
	permalink: PropTypes.string.isRequired,
	post_title: PropTypes.string.isRequired,
	chapo: PropTypes.string,
}



// WEBPACK FOOTER //
// ./js/website/react_components/teasers/Media.js